/* Scoped product-details control. No cart, gallery, form or tracking changes. */
(function () {
  'use strict';
  var triggerSelector = '.ps-buy-cro-hero .ps-hero-post-grid .ps-accordion-trigger';
  function prepare(scope) {
    (scope || document).querySelectorAll(triggerSelector).forEach(function (button, index) {
      if (button.dataset.psDetailsReady) return;
      var item = button.closest('.ps-accordion-item');
      var body = item && item.querySelector('.ps-accordion-body');
      if (!body) return;
      var root = button.closest('product-info');
      var prefix = root ? root.id : 'PurestProduct';
      if (!body.id) body.id = prefix + '-details-' + index;
      button.setAttribute('role', 'button');
      button.setAttribute('tabindex', '0');
      button.setAttribute('aria-controls', body.id);
      button.setAttribute('aria-expanded', 'false');
      body.style.display = 'none';
      body.setAttribute('aria-hidden', 'true');
      button.dataset.psDetailsReady = '1';
    });
  }
  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest(triggerSelector);
    if (!button) return;
    prepare();
    var body = document.getElementById(button.getAttribute('aria-controls'));
    if (!body) return;
    /* Prevent the older delegated jQuery accordion from toggling a second time. */
    event.preventDefault();
    event.stopImmediatePropagation();
    var open = button.getAttribute('aria-expanded') !== 'true';
    button.setAttribute('aria-expanded', String(open));
    button.classList.toggle('active', open);
    button.closest('.ps-accordion-item').classList.toggle('active', open);
    body.style.display = open ? 'block' : 'none';
    body.setAttribute('aria-hidden', String(!open));
  }, true);
  document.addEventListener('keydown', function (event) {
    var button = event.target.closest && event.target.closest(triggerSelector);
    if (!button || (event.key !== 'Enter' && event.key !== ' ')) return;
    event.preventDefault();
    if (!event.repeat) button.click();
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { prepare(); }, {once:true});
  else prepare();
  document.addEventListener('shopify:section:load', function () { prepare(); });
})();
